import React, {Component, Fragment} from 'react'
import {
    Row,
    Col,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap'
import autobind from 'auto-bind'

export default class extends Component {
    constructor(props) {
        super(props)
        autobind(this)
    }

    render() {
        const {modal, toggleModal} = this.props

        return (
            <Fragment>
                <Modal isOpen={modal} toggle={toggleModal}>
                    <ModalHeader toggle={toggleModal}>
                        Are you sure?
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col xs="12" className="mb-4">
                                <p className="text-center">
                                    Cancelling will discard any changes you have
                                    made.
                                </p>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="danger"
                            onClick={() => {
                                this.props.history.push({
                                    pathname: '/app/core/flows',
                                    state: {device: this.props.device},
                                })
                            }}>
                            I'm sure
                        </Button>
                        <Button color="primary" onClick={toggleModal}>
                            Continue Editing
                        </Button>
                    </ModalFooter>
                </Modal>
            </Fragment>
        )
    }
}
